import ErrorManager from '@/common/utils/ErrorManager';
import EstimateWidgetItems from '@/models/EstimateWidgetItems';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import HomeService from '@/modules/Home/services/HomeService';
import { RootState } from '@/plugins/store';
import { ActionTree, Commit, MutationTree } from 'vuex';
import { ESTIMATE_WIDGET } from '../mutation-types';
import { FiltreStats } from '@/models/FiltreStats';
import dayjs from 'dayjs';

export interface WidgetDevisState {
    estimateItems: EstimateWidgetItems;
    isLoading: boolean;
    error: boolean;
    dateDebut: string;
    dateFin: string;
}

export enum EstimateAction {
    GET_ESTIMATE_DATA = 'GET_ESTIMATE_DATA',
}

interface EstimateActionType {
    commit: Commit;
    state: WidgetDevisState;
}

const initialState = (): WidgetDevisState => ({
    estimateItems: {
        nbPublies: 0,
        nbEnCommande: 0,
        nbRealises: 0,
        nbEnCours: 0,
    },
    isLoading: false,
    error: false,
    dateDebut: dayjs().add(-3, 'month').format('YYYY-MM-DD'),
    dateFin: dayjs().format('YYYY-MM-DD'),
});

const actions: ActionTree<WidgetDevisState, RootState> = {
    async [EstimateAction.GET_ESTIMATE_DATA]({ commit, state }: EstimateActionType, siteIds: number[]): Promise<void> {
        if (!state.isLoading) {
            const filtre: FiltreStats = { siteIds: siteIds, dateDebut: state.dateDebut, dateFin: state.dateFin };
            commit(ESTIMATE_WIDGET.SET_LOADING, true);
            HomeService.getEstimateData(filtre)
                .then(async response => {
                    if (response !== undefined || response.status !== undefined) {
                        if (response.status !== 200) {
                            commit(ESTIMATE_WIDGET.SET_ERROR, true);
                            commit(ESTIMATE_WIDGET.SET_LOADING, false);
                            commit(
                                `errorToaster/${ERROR.SET_MESSAGE}`,
                                await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                                { root: true }
                            );
                        }
                        const estimateData: EstimateWidgetItems = response.data;
                        commit(ESTIMATE_WIDGET.SET_ITEMS, estimateData);
                        commit(ESTIMATE_WIDGET.SET_LOADING, false);
                    } else {
                        commit(ESTIMATE_WIDGET.SET_ERROR, true);
                        commit(ESTIMATE_WIDGET.SET_LOADING, false);
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                            { root: true }
                        );
                    }
                })
                .catch(async error => {
                    commit(ESTIMATE_WIDGET.SET_ERROR, true);
                    commit(ESTIMATE_WIDGET.SET_LOADING, false);
                    commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
                });
        }
    },
};

const mutations: MutationTree<WidgetDevisState> = {
    [ESTIMATE_WIDGET.SET_LOADING](state: WidgetDevisState, isLoading: boolean): void {
        state.isLoading = isLoading;
    },
    [ESTIMATE_WIDGET.SET_ERROR](state: WidgetDevisState, error: boolean): void {
        state.error = error;
    },
    [ESTIMATE_WIDGET.SET_ITEMS](state: WidgetDevisState, items: EstimateWidgetItems): void {
        state.estimateItems = items;
    },
    [ESTIMATE_WIDGET.RESET](state: WidgetDevisState): void {
        Object.assign(state, initialState());
    },
};

const estimate = {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
};

export default estimate;
